import Vue from 'vue'

import { slug, lowercase, dashed } from './Utilities'

Vue.filter('slug', slug)
Vue.filter('lowercase', lowercase)
Vue.filter('dashed', dashed)
